<template>
  <div class="articleDetail">
    <p style="text-align: center;font-size: 18px">{{info.Title}}</p>
    <div v-html="info.Text"></div>
  </div>
</template>

<script>
export default {
  name: 'articleDetail',
  data () {
    return {
      info: {}
    }
  },
  components: {},
  methods: {
    getArticleDetail(){
      const params = {
        Id: this.$route.query.Id
      }
      this.$post('/BizMemberArticle/Details',params).then(res => {
        if (res) {
          this.info = res.Data
        }
      })
    }
  },
  mounted () {
    this.getArticleDetail()
  }
}
</script>

<style lang="less">
  .articleDetail{
    img{
      max-width: 100%;
    }
  }
</style>
